import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { StreamTypes } from 'store/player/actions.types';
import {
    selectAppSessionId,
    selectVideoSessionId,
} from 'store/session/selectors';

import {
    MOBILE_PLAYBACK_CONTENT_SOURCE,
    getPlayBackType,
} from 'services/uav/utils';

import { DeepLinkTriggered } from 'components/Ribbon/types';

import { DeeplinkTriggeredUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';

export default function useGetDeepLinkTriggeredParams() {
    const appSessionId = useSelector(selectAppSessionId);
    const genericVideoSessionId = useSelector(selectVideoSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getDeepLinkTriggeredParams = useCallback(
        ({
            templateId,
            railId,
            deeplinkProviderId,
            providerResourceId,
            deepLinkid,
            id,
            playbackType,
        }: DeepLinkTriggered & {
            templateId: string;
            railId?: string;
        }): DeeplinkTriggeredUavParams | undefined => {
            const baseUavParams = getBaseUavParams(
                UavEvents.DEEPLINK_TRIGGERED,
            );

            if (baseUavParams) {
                return {
                    ...baseUavParams,
                    metadata: {
                        contentSource: MOBILE_PLAYBACK_CONTENT_SOURCE,
                        contentType: getPlayBackType(
                            playbackType as unknown as StreamTypes,
                        ),
                        appSessionId,
                        deeplinkProviderId,
                        providerResourceId,
                        deepLinkid,
                        railId,
                        templateId,
                        editorialID: id,
                        playbackSessionId: genericVideoSessionId,
                        ...baseUavParams.metadata,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId, genericVideoSessionId],
    );

    return {
        getDeepLinkTriggeredParams,
    };
}
